type Ga4EventParams = Record<string, unknown>;

// Same ID as in index.html (single Google tag per page).
const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-TP8G9V5T4N';

let isInitialized = false;

function ensureGtagDefined() {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === 'function') return;
  window.gtag = (...args: unknown[]) => {
    window.dataLayer?.push(args);
  };
}

/** Ensures gtag is available (script is loaded from index.html). No duplicate config. */
export function initGa4() {
  if (isInitialized) return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  isInitialized = true;
  ensureGtagDefined();
  // Script and gtag('config') are in index.html — do not load or config again.
}

export function trackPageView(pagePathWithSearch: string) {
  if (!GA4_MEASUREMENT_ID) return;
  initGa4();

  const pagePath = pagePathWithSearch || '/';
  const pageLocation =
    typeof window !== 'undefined' && window.location
      ? window.location.origin + pagePath
      : pagePath;

  window.gtag?.('event', 'page_view', {
    page_path: pagePath,
    page_location: pageLocation,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
  });
}

export function trackEvent(eventName: string, params: Ga4EventParams = {}) {
  if (!GA4_MEASUREMENT_ID) return;
  initGa4();
  window.gtag?.('event', eventName, params);
}

